import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { APPLICATIONS_ACCESS_LEVEL } from '@portal-workspace/grow-shared-library';
import {getUser} from '@portal-workspace/grow-ui-library';
import { navigationUrlForNewApplication } from '../service/navigation-urls';


export const allApplicationsAccessGuard  = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser()
    
    if (user?.priviledges.some(priviledge => APPLICATIONS_ACCESS_LEVEL.includes(priviledge))) {
        return true;
    }
    return router.navigate(navigationUrlForNewApplication())
  }
}
